// client/src/coms/voip/pushToTalkPrefs.js

const KEY_ENABLED = 'coms_ptt_enabled';
const KEY_KEYCODE = 'coms_ptt_key_code';

export function getPushToTalkEnabled() {
  try {
    const v = localStorage.getItem(KEY_ENABLED);
    if (v === '1' || v === 'true') return true;
    return false;
  } catch {
    return false;
  }
}

export function setPushToTalkEnabled(enabled) {
  try {
    if (enabled) localStorage.setItem(KEY_ENABLED, '1');
    else localStorage.setItem(KEY_ENABLED, '0');
  } catch {
    return;
  }
}

export function getPushToTalkKeyCode() {
  try {
    return localStorage.getItem(KEY_KEYCODE) || 'Space';
  } catch {
    return 'Space';
  }
}

export function setPushToTalkKeyCode(code) {
  try {
    const c = String(code || '').trim();
    if (!c) {
      localStorage.setItem(KEY_KEYCODE, 'Space');
      return;
    }
    localStorage.setItem(KEY_KEYCODE, c);
  } catch {
    return;
  }
}

export function emitPushToTalkPrefsChanged(payload) {
  try {
    window.dispatchEvent(new CustomEvent('coms-ptt-changed', { detail: payload || {} }));
  } catch {
    return;
  }
}
